/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiReferencenumberDelete } from '../fn/reference-number/api-referencenumber-delete';
import { ApiReferencenumberDelete$Params } from '../fn/reference-number/api-referencenumber-delete';
import { apiReferencenumberGet } from '../fn/reference-number/api-referencenumber-get';
import { ApiReferencenumberGet$Params } from '../fn/reference-number/api-referencenumber-get';
import { apiReferencenumberPost } from '../fn/reference-number/api-referencenumber-post';
import { ApiReferencenumberPost$Params } from '../fn/reference-number/api-referencenumber-post';
import { NotificationMessage } from '../models/notification-message';
import { ReferenceNumberInfoDto } from '../models/reference-number-info-dto';

@Injectable({ providedIn: 'root' })
export class ReferenceNumberService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiReferencenumberGet()` */
  static readonly ApiReferencenumberGetPath = '/api/referencenumber';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiReferencenumberGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiReferencenumberGet$Response(params?: ApiReferencenumberGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ReferenceNumberInfoDto>>> {
    return apiReferencenumberGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiReferencenumberGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiReferencenumberGet(params?: ApiReferencenumberGet$Params, context?: HttpContext): Observable<Array<ReferenceNumberInfoDto>> {
    return this.apiReferencenumberGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ReferenceNumberInfoDto>>): Array<ReferenceNumberInfoDto> => r.body)
    );
  }

  /** Path part for operation `apiReferencenumberPost()` */
  static readonly ApiReferencenumberPostPath = '/api/referencenumber';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiReferencenumberPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiReferencenumberPost$Response(params?: ApiReferencenumberPost$Params, context?: HttpContext): Observable<StrictHttpResponse<NotificationMessage>> {
    return apiReferencenumberPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiReferencenumberPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiReferencenumberPost(params?: ApiReferencenumberPost$Params, context?: HttpContext): Observable<NotificationMessage> {
    return this.apiReferencenumberPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<NotificationMessage>): NotificationMessage => r.body)
    );
  }

  /** Path part for operation `apiReferencenumberDelete()` */
  static readonly ApiReferencenumberDeletePath = '/api/referencenumber';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiReferencenumberDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiReferencenumberDelete$Response(params?: ApiReferencenumberDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<NotificationMessage>> {
    return apiReferencenumberDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiReferencenumberDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiReferencenumberDelete(params?: ApiReferencenumberDelete$Params, context?: HttpContext): Observable<NotificationMessage> {
    return this.apiReferencenumberDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<NotificationMessage>): NotificationMessage => r.body)
    );
  }

}
